<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cOoOuZ/tc-custom/9783985317752.jpg" alt="This image is the cover for the book A Start in Life & Another Study of Woman, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Start in Life & Another Study of Woman, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>This is one of Balzac's best stories ever. It's the story of a foolish, spoilt boy who brags about his place in life in front of his intended patron, who's travelling incognito on the same coach. Other occupants of the coach, all dependent on his patronage in one way or another, do the same. The way in which Balzac creates the setting, introduces the characters and leaks in the story of the Comte and how he plans to catch his dishonest steward out but reels in everyone else as well, is nothing short of brilliant. The story demonstrates human frailty with compassion and wisdom.  (goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Honoré de Balzac
      </h2>
      
      <p class="authorDescription body article">Honoré de Balzac, (20 May 1799 – 18 August 1850) was a French novelist and playwright. The novel sequence La Comédie humaine, which presents a panorama of post-Napoleonic French life, is generally viewed as his magnum opus. Owing to his keen observation of detail and unfiltered representation of society, Balzac is regarded as one of the founders of realism in European literature. He is renowned for his multi-faceted characters; even his lesser characters are complex, morally ambiguous and fully human. Inanimate objects are imbued with character as well; the city of Paris, a backdrop for much of his writing, takes on many human qualities. His writing influenced many famous writers, including the novelists Émile Zola, Charles Dickens, Gustave Flaubert, and Henry James, and filmmakers François Truffaut and Jacques Rivette. Many of Balzac's works have been made into films and continue to inspire other writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16257669